export default function useRemoveQuizSerial(Serializer) {
  (Serializer.findProperty('question', 'id') || {}).visible = false;
}
